import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import Modal from "react-modal";

const COLORS = {
  teal: "#437672",
  body: "#4D4B4B",
};

const PRIVACY_POLICY_CONTENT = `
POLÍTICA DE PRIVACIDADE

A TRATAZ – Tratamentos Digitalizados de A a Z (“TRATAZ”) também tem a missão de assegurar a privacidade dos dados pessoais coletados para realização das suas atividades, com o devido cumprimento à Lei Geral de Proteção de Dados Pessoais (Lei 13.709/18) (a “LGPD”) e demais normas, legislações e regulamentos aplicáveis ao tratamento de dados pessoais.

O objetivo desta política é a definição de processos, técnicas e medidas organizacionais adequadas ao tratamento de dados, contra perda, dano ou destruição acidental de dados pessoais, e, assim, garantir que os dados pessoais estejam protegidos e possibilitar o exercício de direitos pelos titulares.

Quaisquer dúvidas sobre a legislação aplicável, sobre procedimentos ou solicitações que envolvam o tratamento de dados pessoais pela TRATAZ podem ser direcionadas ao endereço eletrônico: contato@trataz.com.

DEFINIÇÕES:

Para fins desta Política de Privacidade, consideram-se:
Dados Pessoais: Qualquer informação relacionada a uma pessoa natural identificada ou identificável. Isso inclui, mas não se limita a, nome, identificação, dados de saúde, informações de contato e dados eletrônicos como endereços IP e cookies.
Dados Sensíveis: Dados pessoais que revelam origem racial ou étnica, convicções religiosas, opiniões políticas, filiação sindical, dados genéticos, biométricos ou relacionados à saúde ou à vida sexual de uma pessoa natural.
Titular dos Dados: A pessoa natural a quem se referem os dados pessoais.
Tratamento: Qualquer operação realizada com dados pessoais, tais como coleta, registro, organização, estruturação, armazenamento, adaptação ou alteração, recuperação, consulta, uso, divulgação por transmissão, disseminação ou disponibilização, alinhamento ou combinação, restrição, exclusão ou destruição.
Controlador: Pessoa natural ou jurídica, de direito público ou privado, que determina as finalidades e os meios de tratamento de dados pessoais.
Operador: Pessoa natural ou jurídica, de direito público ou privado, que trata dados pessoais em nome do controlador.
Encarregado de Dados (Data Protection Officer - DPO): Pessoa indicada pelo controlador para atuar como canal de comunicação entre o controlador, os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD).
Consentimento: Manifestação livre, informada e inequívoca pela qual o titular dos dados concorda com o tratamento de seus dados pessoais para uma ou mais finalidades específicas.
Autoridade Nacional de Proteção de Dados (ANPD): Órgão da administração pública responsável por zelar, implementar e fiscalizar o cumprimento da LGPD em todo o território nacional.
Violação de Dados Pessoais: Brecha de segurança que acarreta, de forma acidental ou ilícita, a destruição, perda, alteração, divulgação ou acesso não autorizado a dados pessoais transmitidos, armazenados ou de outra forma tratados.

DADOS PESSOAIS:

Ao ACEITAR esta POLÍTICA DE PRIVACIDADE, você CONCORDA que a TRATAZ fica autorizada a tomar decisões referentes ao tratamento e a realizar o tratamento dos dados pessoais fornecidos pelo titular na plataforma da TRATAZ, no sítio eletrônico https://trataz.com.br

Em específico os Dados:
Nome e Sobrenome;
Data de nascimento;
Número do Cadastro de Pessoas Físicas – CPF;
Endereço completo;
Números de telefone, WhatsApp, e endereços eletrônicos;
Data de Nascimento, idade, aniversário;
Fotografia (opcional);
Tratamento e Histórico do Paciente;
Nome de usuário e senha específicos para uso dos serviços do Controlador; e
Comunicação, verbal e escrita, mantida entre o Titular e o Controlador, que possa identificar o Titular.

FINALIDADE:

Esta Política de Privacidade estabelece os princípios e pautas de atuação que regem esta organização em matéria de privacidade e proteção de dados pessoais, garantindo, em todo caso, o cumprimento da legislação aplicável.

A TRATAZ se compromete a tratar os dados pessoais exclusivamente para finalidades claras e legítimas, detalhadamente descritas abaixo:
Gestão de Tratamento de Pacientes: Utilizamos os dados pessoais coletados para possibilitar aos profissionais de saúde, especificamente fonoaudiólogos e odontólogos, gerenciar de maneira eficiente o tratamento de seus pacientes. Aqui também inclui o registro de informações de saúde, acompanhamento de progresso, personalização de tratamentos e comunicação efetiva entre profissionais e pacientes.
Desenvolvimento e Oferta de Materiais Educativos: Os dados pessoais são tratados para permitir a criação e oferta de materiais educativos personalizados, incluindo vídeos explicativos, exercícios, quizes e relatórios, destinados a apoiar o tratamento dos pacientes e a promoção de práticas saudáveis. Tais dados auxiliam na elaboração de conteúdos que facilitam a comunicação e o entendimento durante as pré e pós consultas, melhorando a experiência e o engajamento dos pacientes.
Aprimoramento e Personalização do Serviço: Os dados pessoais são utilizados para aprimorar continuamente nossos serviços e plataformas virtuais, garantindo uma experiência personalizada e eficaz para os profissionais de saúde e seus pacientes, o que também inclui a personalização de interfaces, a otimização da usabilidade e a adaptação de funcionalidades com base nas preferências e comportamentos dos usuários.
Comunicação e Suporte ao Usuário: Utilizamos os dados para facilitar a comunicação entre a TRATAZ e os usuários, oferecendo suporte técnico, respondendo a consultas e enviando atualizações importantes sobre o serviço. Isso também inclui a utilização dos dados para o envio de materiais informativos e educativos, bem como notificações sobre novidades ou mudanças nos nossos serviços.
Análise e Pesquisa: Os dados coletados são analisados para conduzir pesquisas e estudos que visam melhorar o entendimento das necessidades dos profissionais de saúde e pacientes, desenvolver novas funcionalidades e serviços e contribuir para a evolução do setor de saúde digital.
Conformidade Legal e Regulatória: Os dados pessoais são tratados para garantir a conformidade da TRATAZ com as leis e regulamentações aplicáveis, incluindo, mas não se limitando, à gestão de registros e ao atendimento de solicitações legais e regulatórias de autoridades competentes.

Além das finalidades específicas acima, também são finalidades o tratamento dos dados pessoais pela TRATAZ:
Possibilitar que a Controladora identifique e entre em contato com o Titular para fins de relacionamento comercial;
Possibilitar que a Controladora elabore contratos comerciais e emita eventuais cobranças em nome do Titular;
Possibilitar que a Controladora envie ou forneça ao Titular seus produtos e serviços, de forma remunerada ou gratuita;
Possibilitar que a Controladora estruture, teste, promova e faça propaganda de produtos e serviços, personalizados ou não ao perfil do Titular;
Possibilitar que a Controladora utilize tais dados em Pesquisas de Mercado;
Possibilitar que a Controladora utilize tais dados na elaboração de relatórios, emissão e melhoria de produtos e serviços;
Possibilitar que a Controladora utilize tais dados para suas peças de Comunicação;
Possibilitar que a Controladora utilize tais dados emissão de Notas Fiscais e documentos financeiros correlatos;
Possibilitar que a Controladora utilize tais dados para facilitar a prestação de serviços diversos além dos primariamente contratados, desde que o titular também demonstre interesse em contratar novos serviços.

PRINCÍPIOS DO TRATAMENTO DOS DADOS PESSOAIS:

Os princípios pelos quais se rege a presente Política são os seguintes:
Princípios gerais:
Todos os integrantes da organização cumprirão a legislação aplicável em matéria de proteção de dados, a que resulte em função do tratamento de dados pessoais que se realize e a que se determine conforme normas ou acordos vinculantes adotados no âmbito da TRATAZ.
A administração atuará para que os princípios abrangidos nesta Política sejam cumpridos:
No desenho e implementação de todos os procedimentos que impliquem o tratamento de dados pessoais;
Nos serviços oferecidos;
Em todos os contratos e obrigações formalizados; e
Na implantação dos sistemas e plataformas que permitam o acesso por parte de colaboradores ou de terceiros a dados pessoais e/ou o recolhimento ou tratamento desses dados.

Princípios relativos ao tratamento de dados pessoais:
As atividades de tratamento de dados pessoais deverão observar a boa-fé e os seguintes princípios:
Finalidade: realização do tratamento para propósitos legítimos, específicos, explícitos e informados ao titular, sem possibilidade de tratamento posterior de forma incompatível com essas finalidades;
Adequação: compatibilidade do tratamento com as finalidades informadas ao titular, de acordo com o contexto do tratamento;
Necessidade: limitação do tratamento ao mínimo necessário para a realização de suas finalidades, com abrangência dos dados pertinentes, proporcionais e não excessivos em relação às finalidades do tratamento de dados;
Livre acesso: garantia, aos titulares, de consulta facilitada e gratuita sobre a forma e a duração do tratamento, bem como sobre a integralidade de seus dados pessoais;
Qualidade dos dados: garantia, aos titulares, de exatidão, clareza, relevância e atualização dos dados, de acordo com a necessidade e para o cumprimento da finalidade de seu tratamento;
Transparência: garantia, aos titulares, de informações claras, precisas e facilmente acessíveis sobre a realização do tratamento e os respectivos agentes de tratamento, observados os segredos comercial e industrial;
Segurança: utilização de medidas técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão;
Prevenção: adoção de medidas para prevenir a ocorrência de danos em virtude do tratamento de dados pessoais;
Não discriminação: impossibilidade de realização do tratamento para fins discriminatórios ilícitos ou abusivos;
Responsabilização e prestação de contas: demonstração, pelo agente, da adoção de medidas eficazes e capazes de comprovar a observância e o cumprimento das normas de proteção de dados pessoais e, inclusive, da eficácia dessas medidas.

BASE LEGAL:

A TRATAZ se compromete a garantir a legalidade no tratamento de dados pessoais, fundamentando suas operações nas seguintes bases legais, conforme estipulado pela LGPD e outras regulamentações aplicáveis:
Consentimento: O titular dos dados concorda de forma explícita e inequívoca com o tratamento de seus dados pessoais para uma ou mais finalidades específicas. O consentimento é coletado de forma clara e distinta de outros termos, podendo ser revogado pelo titular a qualquer momento.
Cumprimento de obrigação legal ou regulatória: O tratamento é necessário para que a TRATAZ cumpra uma obrigação legal ou regulatória a que está submetida, garantindo a aderência às leis e regulamentos do setor de saúde.
Execução de contrato ou procedimentos preliminares relacionados a contrato: Quando o tratamento de dados pessoais é necessário para a execução de um contrato do qual o titular é parte, ou para procedimentos preliminares relacionados a um contrato.
Proteção da vida ou da incolumidade física do titular ou de terceiros: Em situações em que o tratamento de dados pessoais se faz necessário para proteger a vida ou a segurança física do titular ou de terceiros.
Tutela da saúde: Em consonância com as normas da ANVISA e dos Conselhos de Classe relacionados ao objeto da TRATAZ, o tratamento de dados relacionados à saúde pode ser realizado sem o consentimento do titular, mas sob a supervisão de profissionais da saúde, para garantir a prestação adequada de serviços de saúde.
Legítimo interesse: A TRATAZ pode tratar dados pessoais com base em seus legítimos interesses, sempre de forma equilibrada e nunca sobrepondo os interesses, direitos fundamentais e liberdades do titular dos dados.
Proteção ao crédito: Conforme previsto na legislação, o tratamento de dados pessoais também pode ocorrer para proteção ao crédito, uma base legal que permite à TRATAZ adotar procedimentos que assegurem a viabilidade financeira de suas operações.

Para cada tratamento de dados pessoais realizado, a TRATAZ identifica claramente a base legal correspondente, assegurando a transparência e o direito de informação ao titular dos dados

COMPARTILHAMENTO DE DADOS:

A TRATAZ reconhece a importância da privacidade dos dados pessoais e limita o compartilhamento de tais informações às situações necessárias, sempre observando as bases legais e garantindo a proteção adequada:
Prestadores de Serviços e Parceiros: Dados pessoais podem ser compartilhados com parceiros ou prestadores de serviços que nos auxiliam na oferta e aprimoramento de nossos serviços, como empresas de tecnologia da informação, segurança de dados e suporte ao cliente. Todos os parceiros e prestadores de serviços são cuidadosamente selecionados e obrigados a seguir nossos padrões de segurança e privacidade.
Transações Comerciais: Em casos de fusões, aquisições ou outras transações comerciais, dados pessoais podem ser transferidos como parte dos ativos da empresa, sempre respeitando a legislação aplicável e mantendo os titulares informados.
Requisições Legais: A TRATAZ pode ser obrigada a compartilhar dados pessoais com autoridades governamentais ou judiciais em resposta a solicitações legais, dentro dos limites estabelecidos pela lei, assegurando a proteção dos direitos dos titulares.
Com Consentimento: Além dos casos acima, qualquer outro compartilhamento de dados pessoais só será realizado com o consentimento explícito e informado do titular, que tem o direito de revogar tal consentimento a qualquer momento.
Anonimização: Quando possível e relevante, os dados podem ser anonimizados antes do compartilhamento, de forma que não seja possível identificar o titular dos dados, especialmente em situações envolvendo análises estatísticas ou pesquisas de mercado.

A TRATAZ compromete-se a garantir que qualquer compartilhamento de dados seja feito com a máxima segurança, respeitando as finalidades para as quais os dados foram coletados e em conformidade com a legislação aplicável.
A empresa manterá os titulares informados sobre quaisquer mudanças em suas práticas de compartilhamento de dados através de atualizações nesta Política de Privacidade.

ÂMBITO DE APLICAÇÃO:

A presente Política é aplicável aos dados pessoais tratados por meio deste site ou e-mail de contato, e será cumprida pelo(s) administrador(es), diretor(es) e colaborador(es), assim como aos eventuais parceiros comerciais da TRATAZ.

O(A) representante legal compromete-se a observar as previsões desta Política e a promover, sempre que possível, a aplicação de seus princípios.

TRANSFERÊNCIAS INTERNACIONAIS:

A TRATAZ pode transferir dados pessoais para países fora do Brasil em situações específicas, como o uso de servidores em nuvem localizados em outros países ou quando houver necessidade de compartilhamento com parceiros internacionais.
Nos casos de transferência internacional, a TRATAZ adotará todas as medidas necessárias para garantir que seus dados estejam protegidos de acordo com os padrões da LGPD e outras legislações aplicáveis.

DIREITOS DOS TITULARES DE DADOS PESSOAIS:

A todas as pessoas estão assegurados a titularidade de seus dados pessoais e garantidos os direitos fundamentais de liberdade, intimidade e privacidade, nos termos da LGPD (Lei Geral de Proteção de Dados – Lei nº 13.709/18).

O titular dos dados pessoais tem direito, em relação aos dados tratados pela TRATAZ, a qualquer momento e mediante requisição para:
Confirmação da existência de tratamento;
Acesso aos dados;
Correção de dados incompletos, inexatos ou desatualizados;
Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na LGPD;
Portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa, após a devida regulamentação da autoridade nacional, observados os segredos comercial e industrial;
Eliminação dos dados pessoais tratados com o consentimento do titular, exceto nas hipóteses previstas no art. 16, da LGPD;
Informação das entidades públicas e privadas com as quais realizou uso compartilhado de dados;
Informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;
Revogação do consentimento, caso esta seja a hipótese de tratamento utilizada pela TRATAZ.

SEGURANÇA DOS DADOS:

Na TRATAZ, levamos a segurança dos seus dados pessoais e de saúde extremamente a sério. Implementamos uma série de medidas de segurança técnica e organizacional para proteger seus dados contra acesso, divulgação, alteração ou destruição não autorizada.

Aqui estão as principais medidas que adotamos para garantir a segurança e a integridade das suas informações:
Criptografia de Dados: Todos os dados transmitidos e armazenados em nossos sistemas são protegidos usando tecnologia de criptografia de ponta a ponta, assegurando que suas informações sejam acessíveis apenas por pessoas autorizadas.
Controle de Acesso: Implementamos controles de acesso estritos, onde somente pessoal autorizado pode acessar informações sensíveis. A autenticação multifatorial é um requisito para todos os nossos funcionários e colaboradores que acessam sistemas contendo dados de saúde.
Monitoramento e Detecção de Intrusão: Nossos sistemas são monitorados continuamente para detectar e responder prontamente a qualquer atividade suspeita, ajudando a prevenir qualquer potencial violação de segurança.
Gerenciamento de Vulnerabilidades: Realizamos avaliações regulares e testes de penetração para identificar e corrigir proativamente quaisquer vulnerabilidades em nossos sistemas e aplicações.
Segurança Física: Nossos servidores e infraestrutura de TI estão localizados em instalações seguras, com acesso controlado para prevenir acessos físicos não autorizados.
Políticas de Privacidade e Segurança de Dados: Mantemos políticas internas rigorosas de privacidade e segurança de dados, garantindo que nossa equipe esteja plenamente consciente de suas responsabilidades em proteger suas informações.
Treinamento de Conscientização em Segurança: Todos os nossos funcionários recebem treinamento regular sobre práticas seguras de manuseio de dados e conscientização sobre ameaças cibernéticas.
Plano de Resposta a Incidentes: Possuímos um plano de resposta a incidentes para lidar com eventuais violações de segurança, permitindo uma reação rápida e efetiva para minimizar qualquer impacto sobre seus dados.
Backup e Recuperação de Dados: Efetuamos backups regulares para garantir a restauração eficiente de dados em caso de perda ou dano, protegendo a continuidade do acesso às suas informações.
Conformidade com Normas de Segurança: Estamos em conformidade com as normas e regulamentos de segurança de dados aplicáveis, reforçando nosso compromisso com a proteção e privacidade das suas informações.
Levamos a sua privacidade muito a sério e estamos comprometidos em proteger suas informações. Se tiver alguma dúvida ou preocupação sobre como seus dados são protegidos, não hesite em entrar em contato conosco.

A Controladora é responsável pelas medidas de segurança técnicas e administrativas aptas a proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou qualquer forma de tratamento inadequado ou ilícito.

Em conformidade ao art. 48 da LGPD, a Controladora comunicará ao Titular e à Autoridade Nacional de Proteção de Dados (ANPD) a ocorrência de incidente de segurança que possa acarretar risco ou dano relevante ao Titular.

RETENÇÃO DE DADOS:

A TRATAZ está comprometida com o princípio da minimização do armazenamento, garantindo que os dados pessoais sejam retidos apenas pelo tempo necessário para cumprir as finalidades para as quais foram coletados, respeitando as seguintes diretrizes:
Período de Retenção: Os dados pessoais serão mantidos enquanto a conta do usuário estiver ativa ou enquanto for necessário para fornecer os serviços. Adicionalmente, alguns dados podem ser retidos por períodos mais extensos quando exigido por obrigações legais, fiscais ou regulatórias, ou para fins de proteção em caso de disputas legais.
Critérios para Definição de Prazos: Os prazos de retenção são baseados em critérios como a natureza e a sensibilidade dos dados, as finalidades para as quais são tratados, os requisitos legais aplicáveis e as possíveis necessidades de retenção para proteção legal ou conformidade regulatória.
Revisão dos Prazos de Retenção: A TRATAZ realiza revisões periódicas de suas políticas de retenção de dados para garantir que sejam adequadas e que os dados não sejam mantidos além do necessário.
Exclusão ou Anonimização: Após o término do período de retenção, os dados pessoais são devidamente excluídos ou anonimizados, de modo que o titular não possa ser identificado, exceto quando a manutenção dos dados for exigida por lei.
Solicitações de Exclusão pelo Titular: Respeitando os direitos dos titulares, a TRATAZ permite que os usuários solicitem a exclusão de seus dados pessoais quando não mais desejarem utilizar nossos serviços ou quando os dados não forem mais necessários para as finalidades para as quais foram coletados, ressalvadas as disposições legais contrárias.
Segurança na Exclusão: A TRATAZ assegura que a exclusão dos dados seja realizada de forma segura e definitiva, empregando métodos que impedem a recuperação ou restauração dos dados.

A TRATAZ adota uma abordagem responsável e legalmente compatível em relação à retenção de dados pessoais, garantindo que não sejam armazenados por mais tempo do que o necessário para os fins para os quais foram coletados ou conforme exigido pela legislação aplicável:
Período Máximo de Retenção: Os dados pessoais são mantidos por no máximo [especificar período] após o término da relação contratual ou último contato do usuário, a menos que obrigações legais ou regulatórias exijam um período de retenção mais longo. Por exemplo, registros contábeis e fiscais podem ser mantidos por até [X anos] para cumprir com as legislações tributárias.
Processo de Exclusão e Anonimização: Ao final do período de retenção, os dados pessoais são submetidos a um processo seguro de exclusão ou são anonimizados, de modo que a informação não possa ser reconectada a um indivíduo. A exclusão é realizada de forma que os dados não possam ser recuperados ou restaurados, enquanto a anonimização remove permanentemente os identificadores associados aos dados.
Solicitações de Exclusão pelo Titular: Os titulares dos dados têm o direito de solicitar a exclusão de seus dados a qualquer momento. Após receber uma solicitação de exclusão, a TRATAZ se compromete a eliminar os dados pessoais relevantes dentro de 30 dias, contados a partir da data de recebimento da solicitação, salvo se houver uma base legal para a retenção dos dados.
Notificação de Exclusão: Os titulares dos dados serão informados uma vez que a exclusão tenha sido concluída ou se houver razões legais que impeçam a remoção completa dos dados.

A TRATAZ está comprometida em respeitar as preferências dos titulares dos dados e em cumprir rigorosamente as legislações aplicáveis em relação à retenção e exclusão de dados pessoais, aplicando as melhores práticas de segurança e privacidade.

Ao definir e aderir a estas políticas de retenção de dados, a TRATAZ demonstra seu comprometimento com a proteção da privacidade e dos dados pessoais, alinhando suas práticas com as exigências legais e as melhores práticas do setor.

RESPONSABILIDADE E GOVERNANÇA DE DADOS:

A TRATAZ adota uma estrutura rigorosa de governança e responsabilidade em relação ao tratamento de dados pessoais, garantindo conformidade contínua com a legislação de proteção de dados e incorporando as melhores práticas do setor:
Compromisso com a Conformidade: A TRATAZ está comprometida em manter um programa de conformidade com a LGPD e outras normas aplicáveis de proteção de dados, que inclui a revisão e atualização regular de políticas, treinamento de colaboradores e avaliação contínua dos processos de tratamento de dados.
Encarregado de Dados (DPO): A TRATAZ nomeou um Encarregado de Proteção de Dados (DPO), responsável por monitorar a conformidade com as leis de proteção de dados, servir como ponto de contato com os titulares dos dados e a Autoridade Nacional de Proteção de Dados (ANPD), e aconselhar a empresa sobre práticas de proteção de dados. O DPO pode ser contatado através do e-mail: [inserir e-mail do DPO].
Treinamento e Conscientização: Todos os funcionários da TRATAZ recebem treinamento regular sobre os princípios de proteção de dados e as práticas específicas necessárias para manter a conformidade e proteger os direitos dos titulares dos dados.
Auditorias e Avaliações de Risco: Realizamos auditorias periódicas e avaliações de risco para identificar e mitigar possíveis vulnerabilidades no tratamento de dados pessoais, garantindo que as medidas de segurança e as práticas de governança estejam sempre alinhadas com os mais altos padrões.
Processos de Resposta a Incidentes: A TRATAZ possui procedimentos claros para a detecção, notificação e resposta a incidentes de segurança de dados, assegurando uma reação rápida e eficaz para minimizar possíveis danos decorrentes de tais incidentes.
Diálogo com Stakeholders: Mantemos um diálogo aberto e transparente com titulares de dados, autoridades regulatórias, parceiros e o público em geral sobre nossas práticas de tratamento de dados, reforçando nosso compromisso com a responsabilidade e a transparência.

A governança de dados na TRATAZ é uma função essencial que permeia todos os níveis da organização, assegurando que a privacidade e a proteção dos dados pessoais sejam mantidas em todas as operações e decisões da empresa.

ATUALIZAÇÃO DA POLÍTICA DE PRIVACIDADE:

Esta Política de Privacidade será revisada e atualizada periodicamente para garantir a conformidade contínua com a legislação vigente. Encorajamos os titulares dos dados a revisá-la regularmente para se informarem sobre quaisquer mudanças.

Esta Política foi aprovada em 27/07/2023 e revisada em 15/03/2024.

TRATAZ - Tratamentos Digitalizados de A a Z.
`;

const sectionTitles = new Set([
  "POLÍTICA DE PRIVACIDADE",
  "DEFINIÇÕES:",
  "DADOS PESSOAIS:",
  "FINALIDADE:",
  "PRINCÍPIOS DO TRATAMENTO DOS DADOS PESSOAIS:",
  "BASE LEGAL:",
  "COMPARTILHAMENTO DE DADOS:",
  "ÂMBITO DE APLICAÇÃO:",
  "TRANSFERÊNCIAS INTERNACIONAIS:",
  "DIREITOS DOS TITULARES DE DADOS PESSOAIS:",
  "SEGURANÇA DOS DADOS:",
  "RETENÇÃO DE DADOS:",
  "RESPONSABILIDADE E GOVERNANÇA DE DADOS:",
  "ATUALIZAÇÃO DA POLÍTICA DE PRIVACIDADE:",
]);

const policyBlocks = PRIVACY_POLICY_CONTENT.trim().split(/\n{2,}/);

const PrivacyModalRoot = styled(Modal)`
  position: absolute;
  inset: 50% auto auto 50%;
  transform: translate(-50%, -50%);
  width: min(1120px, calc(100vw - 32px));
  max-height: calc(100vh - 32px);
  overflow: auto;
  background: #fff;
  border-radius: 8px;
  outline: none;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.24);
`;

const ModalInner = styled.div`
  ${tw`relative`}
  padding: 2.25rem 1.5rem 2.6rem;
  background: #fff;

  @media (min-width: 1024px) {
    padding: 3.2rem 4.2rem 3.3rem;
  }
`;

const ModalClose = styled.button`
  ${tw`absolute`}
  top: 1rem;
  right: 1rem;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 9999px;
  background: rgba(0, 0, 0, 0.06);
  color: #444;
  font-size: 20px;
  cursor: pointer;
  z-index: 3;
`;

const Header = styled.div`
  ${tw`grid gap-6 items-center`}
  max-width: 1000px;
  margin: 0 auto;

  @media (min-width: 1024px) {
    grid-template-columns: 96px 1fr;
    column-gap: 1.4rem;
    align-items: center;
  }
`;

const BrandLogo = styled.img`
  width: 104px;
  height: auto;
  display: block;
  margin: 0 auto;

  @media (min-width: 1024px) {
    width: 96px;
    margin: 0;
  }
`;

const PolicyTitle = styled.h2`
  margin: 0;
  font-family: "Montserrat", sans-serif;
  font-size: 20px;
  line-height: 1.12;
  font-weight: 700;
  color: ${COLORS.body};
  text-transform: uppercase;
  text-align: center;

  @media (min-width: 1024px) {
    font-size: 24px;
  }
`;

const Divider = styled.div`
  max-width: 1000px;
  margin: 1.8rem 0 2rem;
  border-top: 2px solid #d9d9d9;

  @media (min-width: 1024px) {
    margin: 1.9rem auto 2rem;
    border-top-width: 2px;
  }
`;

const Content = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  font-family: "Montserrat", sans-serif;
  color: ${COLORS.body};
`;

const SectionHeading = styled.h2`
  margin: 2rem 0 0.8rem;
  font-size: 18px;
  line-height: 1.18;
  font-weight: 700;
  color: ${COLORS.teal};
  text-transform: uppercase;

  &:first-child {
    margin-top: 0;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
  }
`;

const Paragraph = styled.p`
  margin: 0.7rem 0 0;
  white-space: pre-line;
  font-size: 15px;
  line-height: 1.55;
  font-weight: 400;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

export default function PrivacyPolicyModal({ isOpen, onRequestClose }) {
  return (
    <PrivacyModalRoot
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick
      overlayClassName="plans-modal-overlay"
    >
      <ModalInner>
        <ModalClose onClick={onRequestClose} aria-label="Fechar modal">
          ×
        </ModalClose>

        <Header>
          <BrandLogo src="/novas-imagens/logo.png" alt="Trataz" />
          <PolicyTitle>Política de Privacidade</PolicyTitle>
        </Header>

        <Divider />

        <Content>
          {policyBlocks
            .slice(1)
            .map((block) =>
              sectionTitles.has(block.trim()) ? (
                <SectionHeading key={block}>{block}</SectionHeading>
              ) : (
                <Paragraph key={block}>{block}</Paragraph>
              )
            )}
        </Content>
      </ModalInner>
    </PrivacyModalRoot>
  );
}
